import { render, staticRenderFns } from "./PreviewDescription.vue?vue&type=template&id=489c41e3"
import script from "./PreviewDescription.vue?vue&type=script&lang=js"
export * from "./PreviewDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports